// import axios from 'axios'
// import cheerio from 'cheerio'

export default {
  name: "TestPC",
  data() {
    return {
      width: document.documentElement.clientWidth || document.body.clientWidth,
      height: document.documentElement.clientHeight || document.body.clientHeight
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      // 目标网站的URL
      const targetUrl = "https://www.baidu.com"; // 替换为你要爬取的金融网站的URL

      // 发起HTTP请求获取页面内容
      // axios.get(targetUrl)
      //   .then(response => {
      //     const html = response.data;
      //     const $ = cheerio.load(html);

      //     // 使用Cheerio选择器来提取你需要的数据
      //     const data = [];

      //     // 示例：假设目标页面上的数据在 class 为 "financial-data" 的元素中
      //     $('.title-content-title').each((index, element) => {
      //       const value = $(element).text();
      //       data.push(value);
      //     });

      //     // 打印爬取到的数据
      //     console.log(data);
      //   })
      //   .catch(error => {
      //     console.error('Error fetching the page:', error);
      //   });
    }
  }
};